import { useSelector } from "react-redux";
import Receipts from "../../../../components/Finance/ProvidersExpenses/Receipts/Receipts";
import { CheckPermissions } from "../../../../logic/Admin/Permissions/CheckPermission/CheckPermissions";
import { selectUserData } from "../../../../features/userSlice";
import Page404 from "../../../../components/Page404/Page403";

const FinanceReceiptsScreen = () => {
  const userData = useSelector(selectUserData);
  const hasViewReceiptsPermission = CheckPermissions(
    userData?.data?.products?.finance,
    "providers_expenses",
    "view_manual_expenses"
  );

  return (
    <>
      {hasViewReceiptsPermission ? (
        <Receipts />
      ) : (
        <Page404 />
      )}
    </>
  );
};

export default FinanceReceiptsScreen;
